"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.FormButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = require("../../Elements/Button/Button");
var _Icon = require("../../Elements/Icon/Icon");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable react/jsx-props-no-spreading */

function SaveBtn({
  text,
  progress,
  disabled,
  onClick,
  icon,
  ...props
}) {
  let progressClass;
  if (progress === 2) {
    progressClass = 'ccl__button--save--is-saving';
  } else if (progress === 3) {
    progressClass = 'ccl__button--save--has-saved';
  } else {
    progressClass = '';
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
    onClick: onClick,
    disabled: disabled,
    type: "submit",
    className: `ccl__button ccl__button--brand-primary ccl__button--large ccl__button--save ccl__button--no-icon ${progressClass}`,
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "ccl__button__text",
      children: text
    }), progress === 2 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: "ccl__button--spinner",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {})]
    }), progress === 1 && icon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      color: "brand",
      type: "chevron-right"
    })]
  });
}
SaveBtn.defaultProps = {
  disabled: false,
  progress: 1,
  onClick: undefined
};

/**
 * Primary UI component for form buttons
 */
const FormButton = ({
  type,
  variant,
  text,
  icon,
  disabled,
  progress,
  onClick,
  ...props
}) => {
  const cssComponentClass = 'ccl__form-button';

  // const cssTextClass = 'ccl__text';

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: cssComponentClass,
    ...props,
    children: [type === 'save' && /*#__PURE__*/(0, _jsxRuntime.jsx)(SaveBtn, {
      icon: icon,
      onClick: onClick,
      text: text,
      disabled: disabled,
      progress: progress,
      ...props
    }), type === 'cancel' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
      variant: "secondary",
      text: text,
      disabled: disabled,
      onClick: onClick,
      ...props
    }), type === 'standard' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
      onClick: onClick,
      variant: variant,
      text: text,
      icon: icon,
      disabled: disabled,
      ...props
    })]
  });
};
exports.FormButton = FormButton;
FormButton.defaultProps = {
  variant: 'brand-primary',
  onClick: undefined,
  disabled: false,
  icon: '',
  progress: 1
};